// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"2104925e","201":"3e7e67dc","350":"48e58c31"}[chunkId] + ".chunk.css";
};